import { useEffect } from 'react';
import { usePortalHrefs } from '../../hooks';
import { useSsoSessionContext } from '../../Session';
import { ModuleConfiguration } from './types';

export const useProtectedPage = ({ isPage, isPublic }: ModuleConfiguration) => {
  const { ssoSession } = useSsoSessionContext();
  const portalAuthHref = usePortalHrefs().auth;

  useEffect(() => {
    const pageNeedsAuth = isPage && !isPublic;
    const noUser = ssoSession && !ssoSession.userGUID;

    if (pageNeedsAuth && noUser && portalAuthHref) {
      console.info('the user needs authentication');
      window.location.assign(portalAuthHref);
    }
  }, [ssoSession, isPage, isPublic, portalAuthHref]);
};
